import { render, staticRenderFns } from "./polygon-style.vue?vue&type=template&id=af5ffff8&"
import script from "./polygon-style.vue?vue&type=script&lang=js&"
export * from "./polygon-style.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports